import { AxiosResponse } from 'axios'
import { useCallback, useState } from 'react'

import { apiCall, ApiConfig } from '../../config/api'

import { WorkOrderReportDashboard } from '../../interfaces'
import { WorkOrderReportFilters } from '../../interfaces/WorkOrder/WorkOrderReportDashboard'

const useWorkOrderDashboard = () => {
  const [error, setError] = useState<string | undefined>(undefined)

  const [loading, setLoading] = useState<boolean>(false)

  const [workOrderDashboardData, setWorkOrderDashboardData] = useState<
    WorkOrderReportDashboard[]
  >([])

  const getWorkOrderDashboard = useCallback(
    async (data: WorkOrderReportFilters) => {
      setLoading(true)
      const formatedInitialDate = data.initialDate.toFormat(
        "yyyy-MM-dd'T'HH:mm:ss"
      )

      const formatedFinalDate = data.finalDate.toFormat("yyyy-MM-dd'T'HH:mm:ss")
      const warehouseId =
        data.warehouseId !== '0' ? `&warehouseId=${data.warehouseId}` : ''

      const URI =
        data.type !== 3
          ? `${ApiConfig.WorkOrderDashboardApi}?dateType=${data.type}&initialDate=${formatedInitialDate}&finalDate=${formatedFinalDate}${warehouseId}`
          : `${ApiConfig.WorkOrderDashboardApi}?dateType=${data.type}${warehouseId}`

      apiCall('GET', URI)
        .then((response: AxiosResponse<WorkOrderReportDashboard[]>) => {
          setWorkOrderDashboardData(response.data)
        })
        .catch(({ data }) => {
          const errorMessage =
            data?.message === undefined
              ? 'Hubo un error a la hora de consultar Dashboard de OT'
              : data.message
          setError(errorMessage)
        })
        .finally(() => setLoading(false))
    },
    []
  )

  return {
    loading,
    error,
    getWorkOrderDashboard,
    workOrderDashboardData
  }
}

export default useWorkOrderDashboard
